import { render, staticRenderFns } from "./footer_default.vue?vue&type=template&id=c4101f02&"
import script from "./footer_default.vue?vue&type=script&lang=js&"
export * from "./footer_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports